const PRESETS = {
  dateTimeWithSec: {
    dateStyle: 'medium',
    timeStyle: 'medium',
  },
  dateTimeShort: {
    dateStyle: 'short',
    timeStyle: 'short',
  },
} as const satisfies Record<string, Intl.DateTimeFormatOptions>;

type FormatPreset = keyof typeof PRESETS;

const cache = new Map<string, Intl.DateTimeFormat>();

let currentLocale = 'en';

export function setDateTimeFormatLocale(locale: string) {
  currentLocale = locale;
  cache.clear();
}

export function formatDateTime(
  value: Date,
  preset?: FormatPreset,
  overrides?: Intl.DateTimeFormatOptions
): string;
export function formatDateTime(
  value: Date | null | undefined,
  preset?: FormatPreset,
  overrides?: Intl.DateTimeFormatOptions
): string | null | undefined;
export function formatDateTime(
  value: Date | null | undefined,
  preset: FormatPreset = 'dateTimeWithSec',
  overrides: Intl.DateTimeFormatOptions = {}
): string | null | undefined {
  if (value === null || value === undefined) {
    return value;
  }

  const options = { ...PRESETS[preset], ...overrides };

  // Create a unique key based on locale + options
  const key = JSON.stringify(options);

  if (!cache.has(key)) {
    cache.set(key, new Intl.DateTimeFormat(currentLocale, options));
  }

  return cache.get(key)!.format(value);
}
